export default __webpack_public_path__ + "static/media/flores.8b322b6f.svg";